import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { hotTags } from '@/mocks/events';
import { site } from '@/mocks/site';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const onSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/timeline?q=${encodeURIComponent(q)}` : '/timeline');
  };

  return (
    <section className="relative flex min-h-[600px] w-full items-center overflow-hidden bg-foreground-950 md:min-h-[700px]">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20editorial%20background%20with%20flowing%20silk%20fabric%20and%20soft%20golden%20light%2C%20deep%20amber%20and%20brick%20red%20gradients%2C%20dark%20moody%20atmosphere%2C%20elegant%20magazine%20cover%20texture%2C%20no%20text%20no%20people&width=1600&height=900&seq=chigua-hero-01&orientation=landscape"
        alt="蝌蚪吃瓜 娱乐事件时间线复盘 - 暖色调抽象背景"
        title="蝌蚪吃瓜 - 时间线梳理与来龙去脉拆解"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-foreground-950/75" />

      <div className="relative z-10 mx-auto w-full px-4 py-24 md:px-6 md:py-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 font-label text-xs tracking-wide text-background-100 backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            娱乐事件 · 时间线复盘 · 深度拆解
          </span>

          <h1 className="mt-6 font-heading text-5xl font-bold tracking-tight text-background-50 md:text-7xl">
            蝌蚪吃瓜
          </h1>
          <p className="mt-4 font-heading text-xl text-accent-200 md:text-3xl">
            {site.slogan}
          </p>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
            从事件起点到发酵节点，把来龙去脉排成一条清晰的时间线。前因、经过、当后果逐段拆开，三条线吃透整件事。
          </p>

          <form
            onSubmit={onSearch}
            role="search"
            className="mt-8 flex w-full max-w-xl flex-col gap-2 rounded-lg border border-background-50/20 bg-background-50/10 p-2 backdrop-blur sm:flex-row"
          >
            <div className="flex flex-1 items-center gap-2 px-3">
              <i className="ri-search-line text-lg text-background-100/70" />
              <label htmlFor="hero-search" className="sr-only">
                搜索事件关键词
              </label>
              <input
                id="hero-search"
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入事件或人物关键词，比如「换角」"
                className="w-full bg-transparent py-2.5 text-sm text-background-50 placeholder:text-background-100/60 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              开始梳理
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <span className="font-label text-xs text-background-100/70">当前热议：</span>
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/timeline?q=${encodeURIComponent(tag)}`}
                className="rounded-full border border-background-50/25 px-3 py-1 font-label text-xs text-background-100 transition-colors hover:border-accent-300 hover:text-accent-200"
              >
                {tag}
              </Link>
            ))}
          </div>

          <dl className="mt-12 grid w-full max-w-2xl grid-cols-2 gap-4 border-t border-background-50/15 pt-8 md:grid-cols-4">
            {site.stats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center">
                <dt className="font-label text-xs text-background-100/70">{stat.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}